// Lightweight in-memory cache for static master/reference data that rarely
// changes within a session (route managers, transaction types, GL accounts, ...).
//
// It caches the *promise*, so concurrent callers share a single in-flight request
// (de-duplication) and later callers get the resolved value without a network hit.
// Rejected loads are evicted so a transient failure is retried on the next call.
//
// Keys must include any parameters the data depends on (e.g. factoryID/groupID),
// otherwise switching factory/group would serve stale data. Use invalidateLookup()
// when the underlying data is edited elsewhere in the same session.

const cache = new Map();

export function getCachedLookup(key, loader) {
    if (cache.has(key)) {
        return cache.get(key);
    }
    const promise = Promise.resolve()
        .then(loader)
        .catch((error) => {
            cache.delete(key); // never cache a failed load
            throw error;
        });
    cache.set(key, promise);
    return promise;
}

export function invalidateLookup(key) {
    if (key === undefined) {
        cache.clear();
    } else {
        cache.delete(key);
    }
}
